const SHOW_MODE_FLAG = String(import.meta.env.VITE_SHOW_MODE || "").trim();
const SHOW_ASSET_BASE_RAW = String(import.meta.env.VITE_SHOW_ASSET_BASE || "./assets").trim();

function normalizeAssetBase(value: string) {
  const normalized = value.replace(/\/+$/, "");
  return normalized || "./assets";
}

export const isShowMode = SHOW_MODE_FLAG === "1" || SHOW_MODE_FLAG.toLowerCase() === "true";
export const showAssetBase = normalizeAssetBase(SHOW_ASSET_BASE_RAW);

export function buildShowAssetUrl(path: string) {
  const cleaned = String(path || "")
    .trim()
    .replace(/^\/+/, "");
  if (!cleaned) return "";
  return `${showAssetBase}/${encodeURI(cleaned)}`;
}
